import { render, staticRenderFns } from "./safe.vue?vue&type=template&id=66e7d731&scoped=true&"
import script from "./safe.vue?vue&type=script&lang=js&"
export * from "./safe.vue?vue&type=script&lang=js&"
import style0 from "./safe.vue?vue&type=style&index=0&id=66e7d731&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66e7d731",
  null
  
)

export default component.exports